if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartDrawer = document.querySelector("cart-drawer");
        this.quickshop = this.closest("quick-shop-dialog");
        this.isCart = window.location.pathname.includes("/cart");

        // new habitat
        this.qty = this.querySelector("[name=quantity]");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        if (this.cartNotification !== null) {
          this.cartNotification.setActiveElement(document.activeElement);
        }

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        if (this.cartNotification !== null) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }

        // Replace the quantity check with this safer version
        const quantity = this.qty ? this.qty.value : 1;
        formData.append("quantity", quantity);

        console.log(formData);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            if (this.cartNotification !== null) {
              this.cartNotification.renderContents(response);
            }
            if (this.cartDrawer !== null) {
              this.cartDrawer.render();
              this.cartDrawer.open();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            if (this.quickshop) {
              this.quickshop.hide();
            }
            if (this.isCart) {
              window.location.href = "/cart";
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector("[data-product-form-errors]");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            "[data-product-form-error-msg]"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
